/**
 * Ornamentos horizontais para o elemento Espaçador (preview + export HTML).
 * Cores vêm do color picker (#hex); sanitização mínima para SVG.
 */
export const SPACER_DECORATION_IDS = [
  'none',
  'diamond',
  'dots',
  'dashes',
  'stars',
  'circles',
  'heart',
  'infinity',
  'vine',
  'swirl',
  'greek',
  'floral',
  'laurel',
];

function safeStroke(c) {
  const s = String(c || '#64748b').trim();
  if (/^#[0-9A-Fa-f]{3,8}$/.test(s)) return s;
  return '#64748b';
}

/**
 * Retorna HTML interno (SVG) para centralizar no espaçador. Largura fluida.
 */
export function buildSpacerDecorationHtml(deco, color) {
  const stroke = safeStroke(color);
  const w = 400;
  const h = 32;
  const mid = w / 2;

  switch (deco) {
    case 'none':
      return '';
    case 'diamond': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="0" y1="${h / 2}" x2="${mid - 18}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><line x1="${mid + 18}" y1="${h / 2}" x2="${w}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><path d="M${mid} ${h / 2 - 10}l10 10-10 10-10-10z" fill="${stroke}"/></svg>`;
    }
    case 'dots': {
      let d = '';
      for (let x = 20; x < w - 10; x += 14) {
        d += `<circle cx="${x}" cy="${h / 2}" r="3" fill="${stroke}"/>`;
      }
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${d}</svg>`;
    }
    case 'dashes': {
      let lines = '';
      for (let x = 10; x < w - 20; x += 22) {
        lines += `<line x1="${x}" y1="${h / 2}" x2="${x + 14}" y2="${h / 2}" stroke="${stroke}" stroke-width="2" stroke-linecap="round"/>`;
      }
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${lines}</svg>`;
    }
    case 'stars': {
      const stars = [];
      for (let i = 0; i < 7; i++) {
        const cx = 35 + i * 55;
        const cy = h / 2;
        stars.push(`<path d="M${cx} ${cy - 7}l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z" fill="${stroke}"/>`);
      }
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${stars.join('')}</svg>`;
    }
    case 'circles': {
      let c = '';
      for (let x = 24; x < w - 10; x += 28) {
        c += `<circle cx="${x}" cy="${h / 2}" r="5" fill="none" stroke="${stroke}" stroke-width="2"/>`;
      }
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${c}</svg>`;
    }
    case 'heart': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="0" y1="${h / 2}" x2="${mid - 22}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><line x1="${mid + 22}" y1="${h / 2}" x2="${w}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><path d="M${mid} ${h / 2 + 6}c-8-10-18-8-18 2s10 14 18 18c8-4 18-8 18-18s-10-12-18-2z" fill="${stroke}"/></svg>`;
    }
    case 'infinity': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="0" y1="${h / 2}" x2="${mid - 38}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><line x1="${mid + 38}" y1="${h / 2}" x2="${w}" y2="${h / 2}" stroke="${stroke}" stroke-width="2"/><path d="M${mid - 28} ${h / 2}c-8 0-14-5-14-10s6-10 14-10 14 10 28 10 20-10 28-10 14 5 14 10-6 10-14 10-14-10-28-10-20 10-28 10z" fill="none" stroke="${stroke}" stroke-width="2"/></svg>`;
    }
    case 'vine': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 ${h / 2}h${w}" stroke="${stroke}" stroke-width="1.5" fill="none"/><path d="M${mid - 60} ${h / 2}q10-8 20 0t20 0 20 0 20 0 20 0" stroke="${stroke}" fill="none"/><path d="M${mid - 50} ${h / 2 - 2}l-6-8 4 2 6-2-4 8z" fill="${stroke}"/><path d="M${mid + 30} ${h / 2 + 2}l6 8-4-2-6 2 4-8z" fill="${stroke}"/></svg>`;
    }
    case 'swirl': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 ${h / 2 + 6}C30 ${h / 2 - 14} 50 ${h / 2 + 14} ${mid} ${h / 2}" stroke="${stroke}" fill="none" stroke-width="2"/><path d="M${w - 10} ${h / 2 + 6}C${w - 30} ${h / 2 - 14} ${w - 50} ${h / 2 + 14} ${mid} ${h / 2}" stroke="${stroke}" fill="none" stroke-width="2"/><circle cx="${mid}" cy="${h / 2}" r="4" fill="${stroke}"/></svg>`;
    }
    case 'greek': {
      let p = '';
      for (let x = 8; x < w - 24; x += 20) {
        p += `<path d="M${x} ${h / 2 + 8}v-8h8v8h8v-8h8v8" stroke="${stroke}" fill="none" stroke-width="1.8"/>`;
      }
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${p}</svg>`;
    }
    case 'floral': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h + 8}" viewBox="0 0 ${w} ${h + 8}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="0" y1="${h / 2 + 4}" x2="${mid - 35}" y2="${h / 2 + 4}" stroke="${stroke}" stroke-width="1.5"/><line x1="${mid + 35}" y1="${h / 2 + 4}" x2="${w}" y2="${h / 2 + 4}" stroke="${stroke}" stroke-width="1.5"/><circle cx="${mid}" cy="${h / 2 + 4}" r="6" fill="none" stroke="${stroke}" stroke-width="1.5"/><path d="M${mid} ${h / 2 - 6}l4 8-8-3 8-3-4 8z" fill="${stroke}" opacity="0.85"/><ellipse cx="${mid - 14}" cy="${h / 2 + 4}" rx="5" ry="3" fill="${stroke}" opacity="0.5" transform="rotate(-25 ${mid - 14} ${h / 2 + 4})"/><ellipse cx="${mid + 14}" cy="${h / 2 + 4}" rx="5" ry="3" fill="${stroke}" opacity="0.5" transform="rotate(25 ${mid + 14} ${h / 2 + 4})"/></svg>`;
    }
    case 'laurel': {
      return `<svg class="madri-gc-spacer-deco" width="100%" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M${mid} ${h / 2}L20 ${h / 2}" stroke="${stroke}" stroke-width="1.5"/><path d="M${mid} ${h / 2}L${w - 20} ${h / 2}" stroke="${stroke}" stroke-width="1.5"/><path d="M${mid - 8} ${h / 2}l-30-10c4 8 2 18-6 22M${mid + 8} ${h / 2}l30-10c-4 8-2 18 6 22" stroke="${stroke}" fill="none" stroke-width="1.5"/><path d="M${mid - 8} ${h / 2}l-30 10c4-8 2-18-6-22M${mid + 8} ${h / 2}l30 10c-4-8-2-18 6-22" stroke="${stroke}" fill="none" stroke-width="1.5"/></svg>`;
    }
    default:
      return '';
  }
}
